import React__default, { useState, useRef } from 'react';
import { toast } from '../../../node_modules/sonner/dist/index.esm.js';
import AddClient from '../components/AddClient.esm.js';
import Button from '../../button/Button.esm.js';
import SearchClient from '../components/SearchClient.esm.js';
import { useCreateClient } from '../hooks/useCreateClient.esm.js';
import { baseUrl, getMuid } from '../../../lib/utils.esm.js';
import { useProposalContext } from '../proposalContext.esm.js';
import { handleAddOfferToProposal } from '../proposalService.esm.js';
import t from '../../../services/translatorService.esm.js';

const SelectClient = ({
  form,
  onChangeForm,
  selectedClient,
  onSelectClient,
  offerData,
  source
}) => {
  const {
    closeProposal
  } = useProposalContext();
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const proposalName = useRef('');
  const {
    createClient,
    error
  } = useCreateClient();
  const {
    state,
    fetchProposals,
    fetchClients
  } = useProposalContext();
  const containerRef = useRef(null);
  const createClientIfNeeded = async () => {
    if (selectedClient) {
      return state.clients.find(client => client.id === selectedClient) || null;
    }
    if (form && validateForm()) {
      try {
        const client = await createClient(form);
        fetchClients();
        return client || null;
      } catch (error) {
        console.error('Failed to create client:', error);
        return null;
      }
    }
    return null;
  };
  const getProposalName = (client, offer) => {
    return `${client.firstName} ${client.lastName}, ${offer.date}`;
  };
  const handleCreateProposal = async client => {
    try {
      proposalName.current = getProposalName(client, offerData);
      const response = await fetch(`${baseUrl}${window.apiV6Config.path}/b2b/proposal?muid=${getMuid()}&locale=${window.dataGlobalSettings?.locale || 'en'}`, {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          clientId: client.id,
          name: getProposalName(client, offerData),
          searchContext: offerData.searchContext,
          searchCapacity: offerData.searchCapacity,
          searchDuration: offerData.searchDuration
        })
      });
      if (!response.ok) throw new Error('Proposal creation failed');
      const proposal = await response.json();
      await fetchProposals();
      return proposal;
    } catch (error) {
      console.error('Failed to create proposal:', error);
      return null;
    }
  };
  const handleNextClick = async () => {
    setIsLoading(true);
    try {
      const client = await createClientIfNeeded();
      let proposal = null;
      if (!client) {
        console.error('No client available');
        return;
      }
      let proposalId = state.selectedProposal;
      if (!proposalId) {
        proposal = await handleCreateProposal(client);
        if (!proposal) return;
        proposalId = proposal.id;
      }
      await handleAddOfferToProposal(proposalId, offerData, source, proposal);
      closeProposal();
      toast(t('proposals.addOfferSuccessNotification'), {
        className: 'voyage-toast',
        description: proposalName.current,
        duration: 5000,
        icon: /*#__PURE__*/React__default.createElement("i", {
          className: "ri-check-line text-lg text-primary"
        }),
        position: 'bottom-center',
        cancel: /*#__PURE__*/React__default.createElement("div", {
          className: "voyage-toast-close cursor-pointer",
          onClick: () => toast.dismiss()
        }, /*#__PURE__*/React__default.createElement("i", {
          className: "ri-close-line text-lg"
        }))
      });
    } catch (error) {
      console.error('Error in proposal flow:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const validateForm = () => {
    const {
      firstName,
      lastName
    } = form;
    if (firstName === '' || lastName === '') {
      return false;
    }
    // if (email.length > 0 && !emailRegex.test(email)) {
    //   return false
    // }
    return true;
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col gap-2 mb-7 overflow-y-auto h-full",
    ref: containerRef
  }, /*#__PURE__*/React__default.createElement(SearchClient, {
    search: search,
    setSearch: setSearch,
    selectedClient: selectedClient,
    onSelectClient: onSelectClient
  }), search.length === 0 && !selectedClient && /*#__PURE__*/React__default.createElement(AddClient, {
    form: form,
    onChangeForm: onChangeForm,
    errors: error,
    containerRef: containerRef
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-between mt-auto"
  }, /*#__PURE__*/React__default.createElement(Button, {
    label: t('proposals.close'),
    variant: "secondary",
    size: "large",
    onClick: closeProposal,
    rounded: true
  }), /*#__PURE__*/React__default.createElement(Button, {
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, search.length === 0 || selectedClient ? t('proposals.confirm') : t('proposals.next')), /*#__PURE__*/React__default.createElement("i", {
      className: `${document.documentElement.lang === 'he' ? 'ri-arrow-left-line' : 'ri-arrow-right-line'} ms-2`
    })),
    variant: "secondary",
    size: "large",
    onClick: handleNextClick,
    rounded: true,
    disabled: !(validateForm() || selectedClient || isLoading),
    isLoading: isLoading
  })));
};

export { SelectClient as default };
//# sourceMappingURL=SelectClient.esm.js.map
